// src/app/app.routes.ts
import { Routes } from '@angular/router';
import { authRoutes } from './auth/auth.routes';

export const routes: Routes = [
  ...authRoutes, // Spread the auth routes here
  {
    path: 'vendor',
    loadChildren: () => import('./vendor/vendor.module').then((m) => m.VendorModule), // Lazy load VendorModule
  },
  {
    path: 'supplier',
    loadChildren: () => import('./supplier/supplier.module').then((m) => m.SupplierModule), // Lazy load SupplierModule
  },
  {
    path: 'auth',
    loadComponent: () => import('./auth/login/login.component').then((m) => m.LoginComponent), // Auth route
  },
  { path: '', redirectTo: '/auth/login', pathMatch: 'full' }, // Default route
  {
    path: '404',
    loadComponent: () =>
      import('./shared/page-not-found/page-not-found.component').then(
        (m) => m.PageNotFoundComponent,
      ), // 404
  },
  {
    path: 'under-maintenance',
    loadComponent: () =>
      import('./shared/maintenance/maintenance.component').then((m) => m.MaintenanceComponent),
  },
  { path: '**', redirectTo: '/auth/login' }, // Fallback route for unmatched URLs
];
